import React, { useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import cx from 'clsx';
import { selector } from '../../mockdata';
import locales from '../../util/locales';
import Button from '../Button/Button';
import classes from './LanguageSelector.module.scss';

interface LanguageSelectorProps extends React.HTMLProps<HTMLDivElement> {
  locale: string;
  localeCountry?: string;
}

export default function LanguageSelector({
  className,
  locale,
  localeCountry,
  ...others
}: LanguageSelectorProps) {
  const router = useRouter();
  const [value, setValue] = useState(localeCountry ? localeCountry?.split('-')[0] : locale);
  const query = useMemo(() => {
    const clone = { ...router.query };
    delete clone.locale_country;
    return clone;
  }, [router.query]);
  console.log(localeCountry);
  return (
    <div className={cx(classes.languageSelector, className)} {...others}>
      <select value={value} onChange={(e) => setValue(e.target.value)} className={classes.select}>
        {locales
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .map((item, index) => (
            <option value={item.value} key={index}>
              {item.name}
            </option>
          ))}
      </select>
      <Button
        onClick={() =>
          router.push({
            pathname: router.pathname,
            query: {
              ...query,
              ...(localeCountry
                ? { locale_country: `${value}-${localeCountry.split('-')[1]}` }
                : { locale: value }),
            },
          })
        }
      >
        {selector.select_language}
      </Button>
    </div>
  );
}
